"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeConsolidationMapSchema = exports.ModeConsolidationEntrySchema = void 0;
exports.applyModeConsolidation = applyModeConsolidation;
const z = require("zod");
const general_package_slices_1 = require("./general-package-slices");
exports.ModeConsolidationEntrySchema = z.object({
    sourceKey: z.string(),
    keep: z.boolean(),
});
exports.ModeConsolidationMapSchema = exports.ModeConsolidationEntrySchema.array();
function applyModeConsolidation(payload, map, rowKeyOf) {
    const discardedKeys = new Set(map.filter((entry) => !entry.keep).map((entry) => entry.sourceKey));
    if (discardedKeys.size === 0) {
        return { payload, droppedModeIds: [] };
    }
    const discardedModeIds = new Set((0, general_package_slices_1.buildModeRows)(payload)
        .filter((row) => discardedKeys.has(rowKeyOf(row)))
        .map((row) => row.id));
    if (discardedModeIds.size === 0) {
        return { payload, droppedModeIds: [] };
    }
    return {
        payload: { ...payload, modes: payload.modes.filter((mode) => !discardedModeIds.has(mode.id)) },
        droppedModeIds: [...discardedModeIds],
    };
}
//# sourceMappingURL=apply-mode-consolidation-map.js.map